import type { PropsWithChildren } from "react";
import { useState } from "react";
import { VisualContext } from "./VisualContext";

export const VisualContextProvider = ({ children }: PropsWithChildren) => {
  const [showSideMenu, setShowSideMenu] = useState(true);

  return (
    <VisualContext value={{ showSideMenu, toggleSideMenu: () => setShowSideMenu((prev) => !prev) }}>
      {children}
    </VisualContext>
  );
};
